export const homeObjThree = {
    id: 'ourpresence',
    heading: 'Our Presence',
    description: 'Empowering Connections and Creating Impactful Impressions'
};